import React from "react";
import { Quote, BadgeCheck } from "lucide-react";

const PORTRAIT =
    "/assets/coach-melissa-headshot.jpg";

export const HostBio = () => {
    return (
        <section id="host" data-testid="host-section" className="relative py-24 md:py-36 bg-lilac-50/60">
            <div className="mx-auto max-w-7xl px-6 md:px-10">
                <div className="grid grid-cols-12 gap-10 items-center">
                    <div className="col-span-12 lg:col-span-5">
                        <div className="relative">
                            <div className="absolute -top-6 -left-6 w-40 h-40 rounded-full bg-gold/15 blur-3xl" />
                            <div className="relative aspect-[4/5] overflow-hidden rounded-[40px] border border-border shadow-[0_30px_70px_rgba(43,29,53,0.14)]">
                                <img
                                    src={PORTRAIT}
                                    alt="Coach Melissa, host of Becoming H.E.R."
                                    className="w-full h-full object-cover"
                                    data-testid="host-portrait"
                                />
                            </div>
                            <div className="absolute -bottom-6 -right-6 glass rounded-3xl px-5 py-4 shadow-[0_18px_50px_rgba(43,29,53,0.10)]">
                                <div className="eyebrow text-gold-deep flex items-center gap-1.5">
                                    <BadgeCheck className="w-3.5 h-3.5" /> Your host
                                </div>
                                <div className="font-display text-2xl text-lilac-900 leading-tight mt-1">
                                    Coach Melissa
                                </div>
                                <div className="text-xs text-lilac-700 mt-0.5">
                                    Certified Life &amp; Empowerment Coach
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-span-12 lg:col-span-7 lg:pl-10">
                        <div className="eyebrow text-gold-deep mb-6">Meet the woman behind the mic</div>
                        <h2 className="font-display text-4xl md:text-5xl text-lilac-900 leading-tight">
                            She broke the cycle <em className="italic gold-text">first</em>.
                            <br /> Now she's holding the door for you.
                        </h2>
                        <p className="mt-8 text-lilac-700 leading-relaxed max-w-xl">
                            Coach Melissa is a Certified Life &amp; Empowerment Coach guiding women through
                            raw conversations, spiritual encouragement, healing truths, and practical
                            empowerment. Through Becoming H.E.R., she dives deep into breaking toxic
                            patterns, overcoming people pleasing, healing identity wounds, rebuilding
                            self-worth, and learning how to stop shrinking in places God called you to rise.
                        </p>
                        <p className="mt-5 text-lilac-700 leading-relaxed max-w-xl">
                            Your past does not define you — and healing is possible through God's grace,
                            wisdom, and transformation.
                        </p>
                        <div className="mt-10 relative max-w-xl rounded-3xl bg-white border border-border p-8">
                            <Quote className="absolute -top-4 -left-2 w-10 h-10 text-gold/70" />
                            <p className="font-display italic text-xl md:text-2xl text-lilac-900 leading-snug">
                                "Real conversations. Raw healing. Kingdom transformation. This is more
                                than a podcast — this is a journey of becoming."
                            </p>
                            <div className="mt-5 eyebrow text-lilac-700">— Coach Melissa</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
